<template>
	<div class="c-mcp-page">
		<PageHeader title="MCP Server">
			<template v-slot:title> Connect Swipekit to your Chat app </template>
		</PageHeader>
		<Constrain size="sm">
			<div class="c-mcp-page__inner">
				<McpConnectGuide></McpConnectGuide>
				<McpQueryList></McpQueryList>
				<McpToolList></McpToolList>

				<div class="c-mcp-page__connections">
					<h3>Your connected apps</h3>
					<p v-if="connectionError" role="alert">{{ connectionError }}</p>
					<p v-else-if="loadingConnections">Loading connections…</p>
					<p v-else-if="!connections.length">No connected apps yet.</p>
					<ul>
						<li v-for="connection in connections" :key="connection.id">
							<strong>{{ connection.clientName }}</strong> — connected
							{{ formatDate(connection.createdAt) }}
							<button
								type="button"
								class="btn btn-box btn-sm"
								:disabled="revoking === connection.id"
								@click="revoke(connection)"
							>
								Revoke
							</button>
						</li>
					</ul>
				</div>
			</div>
		</Constrain>
	</div>
</template>

<script>
import { http } from '@swipekit/lib/http';
import Constrain from '@swipekit/components/utils/constrain.vue';
import PageHeader from '@swipekit/components/utils/page-header.vue';
import McpConnectGuide from '@swipekit/components/mcp/connect-guide.vue';
import McpToolList from '@swipekit/components/mcp/tool-list.vue';
import McpQueryList from '@swipekit/components/mcp/query-list.vue';

export default {
	name: 'McpPage',
	components: {
		Constrain,
		PageHeader,
		McpConnectGuide,
		McpToolList,
		McpQueryList,
	},

	data: function () {
		return {
			connections: [],
			loadingConnections: false,
			connectionError: '',
			revoking: '',
		};
	},

	watch: {
		isAuth: {
			immediate: true,
			handler: function (value) {
				if (value) {
					this.loadConnections();
				}
			},
		},
	},
	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
	},

	methods: {
		formatDate: function (value) {
			return new Date(value).toLocaleDateString();
		},
		async loadConnections() {
			this.loadingConnections = true;
			this.connectionError = '';
			try {
				this.connections = (await http.get('/mcp/oauth/connections')).data;
			} catch (err) {
				this.connectionError =
					'Could not load connections. Please refresh this page.';
			} finally {
				this.loadingConnections = false;
			}
		},
		async revoke(connection) {
			this.revoking = connection.id;
			try {
				await http.delete(`/mcp/oauth/connections/${connection.id}`);
				this.connections = this.connections.filter(function (item) {
					return item.id !== connection.id;
				});
			} catch (err) {
				this.connectionError =
					'Could not revoke this connection. Please try again.';
			} finally {
				this.revoking = '';
			}
		},
	},
};
</script>

<style lang="scss">
.c-mcp-page {
	padding-bottom: var(--spacer);

	&__inner {
		position: relative;
		z-index: 1;
		padding-top: var(--spacer-sm);
	}

	&__connections {
		margin-top: var(--spacer-sm);

		h3 {
			margin-bottom: 1rem;
		}

		p,
		li {
			font-size: var(--font-size-sm);
		}
	}
}
</style>
